import styles from './styles.css'

const codes = {
  xk: 'Kosovo country',
  an: 'Netherlands Antilles country',
}

export {styles,codes}
